import { TRANSLATE_FIELD_QUERY } from "@app/shared-core/general/translate/queries/translate-field.query";
import { TYPE_COST_TYPE_QUERY } from "./type-cost-type.query";

export const LEVEL_COST_LEVEL_QUERY = `
  id
  name { ${TRANSLATE_FIELD_QUERY} }
  types { ${TYPE_COST_TYPE_QUERY} }
`;
